import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"fluid":""}},[_c(VCard,[_c(VCardText,[_c('crud',{attrs:{"id":"clientes","resource":"clientes","create-permission":"staff","edit-permission":"staff","delete-permission":"staff","revisions":"staff","default-order":"id","hide-delete":"","before-save":_vm.checkDates},on:{"add-item":_vm.setItem,"edit-item":_vm.setItem,"cancel-edition":_vm.setItem}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }